// extracted by mini-css-extract-plugin
export var arrow = "_2y-6";
export var changeItem = "_2y-3";
export var changesHeader = "_2y-1";
export var changesList = "_2y-2";
export var container = "_2y-0";
export var pathLabel = "_2y-4";
export var value = "_2y-7";
export var valuesContainer = "_2y-5";